export function StillCurious({ mainColor }: { mainColor: string }) {
  return (
    <div
      className="container mx-auto px-4 py-0 max-w-[1005px] text-center"
      id="why-us"
    >
      <div className="space-y-4">
        <h2
          className="text-[16px] md:text-lg font-normal md:text-center text-left"
          style={{ color: mainColor }}
        >
          Still Curious?
        </h2>
        <div className="space-y-4">
          <h3 className="text-[32px] md:text-[3rem] font-semibold text-[#2D2D2D] md:text-center text-left leading-[1.2]">
            Why is Famepeak the Best Service
            <br className="hidden md:block" /> for TikTok Users?
          </h3>
          <p className="text-[#626366] leading-tight !text-[18px] md:text-xl max-w-4xl mx-auto md:text-center text-left">
            Social media accounts without followers, likes, and views seem like
            very lonely places – and they're unlikely to attract visitors who
            will come back again and again, and they may not attract visitors at
            all.
          </p>
        </div>
      </div>

      <div className="flex flex-row items-center gap-4 md:gap-8 mb-[1.5rem] border rounded-xl border-gray-100 px-4 md:px-6 py-4 md:py-6 mx-auto w-full mt-8">
        <p className="text-[#757575] text-[14px] md:text-[15px] text-left whitespace-normal">
          Famepeak provides the ultimate TikTok growth service, which will
          jump-start your TikTok presence, provide your page with a feeling of
          community, and turn your TikTok account into a force to be reckoned
          with.
        </p>
        <div className="bg-[#fff3d6] overflow-hidden shrink-0 w-12 md:w-16 h-12 md:h-16 relative rounded-full">
          <svg
            className="!w-[75px] md:!w-[95px] !h-[72px] md:!h-[92px] absolute -left-[20px] md:-left-[25px] -bottom-6 md:-bottom-8"
            width="168"
            height="165"
            viewBox="0 0 168 165"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M121.632 8.47342C121.632 7.20394 122.627 6.17374 123.851 6.17374C125.078 6.17374 126.07 7.20393 126.07 8.47379C126.07 9.74327 125.077 10.7735 123.851 10.7735C123.717 10.7735 123.585 10.7593 123.458 10.7352L116.669 32.0172C105.276 28.7114 99.3442 29.0452 89.2248 32.0168L82.4357 10.7348C82.3077 10.7586 82.1769 10.7731 82.0421 10.7731C80.8173 10.7731 79.8234 9.74328 79.8234 8.47342C79.8234 7.20394 80.8174 6.17374 82.0429 6.17374C83.2677 6.17374 84.2616 7.20356 84.2616 8.47342C84.2616 9.39557 83.7361 10.1883 82.9809 10.5554C85.2176 13.0129 90.8895 18.9211 93.7168 18.9211C98.702 18.9211 101.478 9.09237 102.495 4.55142C101.486 4.33476 100.727 3.409 100.727 2.29967C100.727 1.03019 101.722 0 102.947 0C104.173 0 105.166 1.02981 105.166 2.29967C105.166 3.40938 104.408 4.3352 103.399 4.55142C104.415 9.09275 107.192 18.9211 112.176 18.9211C115.004 18.9211 120.677 13.0129 122.913 10.5554C122.157 10.1883 121.632 9.3955 121.632 8.47342Z"
              fill="#FFCE54"
            ></path>
            <path
              d="M126.782 156.023C135.626 148.842 140.675 137.991 140.472 126.6L139.451 69.1171C139.087 48.6562 122.206 32.3642 101.745 32.7278C81.2842 33.0915 64.9921 49.973 65.3558 70.4338L65.5364 80.5963L66.1327 156.748L95.174 163.381C106.281 165.918 117.937 163.205 126.782 156.023Z"
              fill="url(#paint0_linear_441_3801)"
            ></path>
            <path
              d="M126.782 156.023C135.626 148.842 140.675 137.991 140.472 126.6L139.451 69.1171C139.087 48.6562 122.206 32.3642 101.745 32.7278C81.2842 33.0915 64.9921 49.973 65.3558 70.4338L65.5364 80.5963L66.1327 156.748L95.174 163.381C106.281 165.918 117.937 163.205 126.782 156.023Z"
              fill="#FFCE54"
            ></path>
            <path
              d="M91.1235 52.5144C93.5073 57.3417 99.1599 56.4359 100.735 52.4749M105.581 52.1736C107.965 57.0009 113.618 56.0951 115.193 52.1342M88.6075 61.8735C98.9419 73.451 110.502 70.9298 117.476 58.8342"
              stroke="#A87800"
              stroke-width="2.01524"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
      </div>

      {/* Feature Cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 md:gap-5 gap-3">
        {/* Quick Results Card */}
        <div className="bg-[#fff3d6] rounded-3xl p-8 text-center relative overflow-hidden max-h-[352px]">
          <div className="relative h-20 mb-2 md:h-32 md:mb-6">
            <div className="absolute -left-20 -top-8 md:-left-[130px] md:-top-[32px]">
              <svg
                className="w-[200px] h-[150px] md:w-[360px] md:h-[300px]"
                width="357"
                height="286"
                viewBox="0 0 357 286"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M63.7931 135.419C109.135 154.875 161.739 139.183 200.43 120.715C212.226 115.085 259.197 74.7823 268.785 65.8983C274.642 60.4718 277.712 63.4039 271.739 87.4872C252.688 164.297 48.7558 271.461 21.1551 229.477C-6.44566 187.494 28.403 120.234 63.7931 135.419Z"
                  fill="#F7CB5C"
                ></path>
                <path
                  d="M253.451 47.8404C252.636 48.3594 251.617 48.4436 250.728 48.0656L221.754 35.7548L221.092 35.5153C216.682 34.1923 212.316 38.2207 213.503 42.8583L221.317 73.3862C221.556 74.3202 221.321 75.3121 220.689 76.0397L199.981 99.8519L199.565 100.383C196.908 104.176 199.378 109.594 204.164 109.889L235.596 111.825C236.562 111.885 237.436 112.417 237.933 113.247L254.109 140.267L254.483 140.825C257.262 144.52 263.177 143.832 264.945 139.366L276.561 110.024C276.916 109.127 277.689 108.462 278.628 108.245L309.335 101.147L310.011 100.952C314.361 99.4248 315.533 93.6021 311.847 90.5537L287.586 70.4848C286.841 69.8687 286.447 68.9253 286.533 67.9625L289.337 36.5541C289.784 31.5441 284.298 28.2075 280.055 30.9081L253.451 47.8404Z"
                  fill="#FFCE54"
                ></path>
                <path
                  opacity="0.4"
                  d="M313.686 51.3059C313.577 51.2782 313.476 51.2909 313.384 51.3437C313.291 51.3965 313.218 51.4805 313.164 51.5952L313.101 51.7538L312.975 52.0614C312.705 52.7135 312.448 53.2729 312.203 53.7398C311.901 54.3142 311.582 54.7679 311.244 55.1009C310.906 55.4338 310.514 55.6689 310.067 55.806C309.621 55.9431 309.082 56.005 308.451 55.9913C307.899 55.9793 307.243 55.9247 306.484 55.8273L306.153 55.783C306.029 55.764 305.919 55.7847 305.821 55.8455C305.723 55.9062 305.66 55.994 305.631 56.1088C305.603 56.218 305.618 56.3225 305.674 56.4225C305.731 56.5225 305.818 56.5965 305.934 56.6443L306.246 56.7636C306.96 57.0404 307.564 57.3044 308.058 57.5557C308.622 57.8429 309.068 58.1548 309.394 58.4914C309.72 58.828 309.952 59.2232 310.09 59.677C310.228 60.1309 310.291 60.6803 310.279 61.3256C310.271 61.769 310.24 62.2775 310.184 62.8506L310.152 63.1697L310.115 63.5016C310.108 63.558 310.101 63.615 310.094 63.6724C310.082 63.7917 310.105 63.8983 310.164 63.9927C310.222 64.087 310.306 64.148 310.415 64.1756C310.529 64.2048 310.635 64.1919 310.731 64.1369C310.827 64.0819 310.899 63.9992 310.945 63.8888C311.055 63.6206 311.163 63.3668 311.268 63.1271L311.393 62.8463C311.578 62.4356 311.754 62.0711 311.923 61.7528C312.222 61.187 312.54 60.739 312.877 60.4089C313.215 60.0789 313.606 59.8468 314.052 59.7124C314.498 59.5781 315.036 59.5164 315.668 59.5272C315.787 59.5292 315.91 59.5328 316.037 59.5383L316.3 59.5513C316.344 59.5539 316.389 59.5565 316.435 59.5595L316.716 59.5793C316.764 59.583 316.813 59.5868 316.861 59.5909L317.161 59.6175C317.416 59.6414 317.684 59.6699 317.966 59.7033C318.09 59.7167 318.2 59.6926 318.295 59.6312C318.39 59.5698 318.451 59.4844 318.479 59.3754C318.508 59.2605 318.496 59.1534 318.442 59.0541C318.388 58.9548 318.302 58.884 318.185 58.842L317.872 58.7225L317.573 58.6046C316.988 58.37 316.484 58.1439 316.061 57.9263C315.498 57.6363 315.051 57.324 314.721 56.9895C314.391 56.655 314.159 56.2612 314.024 55.8081C313.889 55.355 313.828 54.8044 313.84 54.1565C313.845 53.9134 313.856 53.6517 313.874 53.3711L313.893 53.0843L313.917 52.7851C313.922 52.7342 313.926 52.6827 313.931 52.6307L313.961 52.3127C313.967 52.2586 313.973 52.2041 313.978 52.149L314.015 51.8121C314.029 51.6872 314.007 51.5793 313.951 51.4886C313.895 51.3979 313.807 51.3372 313.686 51.3066L313.686 51.3059Z"
                  fill="#E9C15C"
                ></path>
                <path
                  opacity="0.7"
                  d="M342.207 43.8687C342.034 43.8247 341.874 43.8448 341.726 43.9289C341.579 44.0129 341.463 44.1464 341.377 44.329L341.276 44.5814L341.077 45.0708C340.647 46.1083 340.237 46.9984 339.848 47.7412C339.368 48.6552 338.859 49.3771 338.322 49.9069C337.784 50.4366 337.16 50.8107 336.45 51.0288C335.739 51.247 334.882 51.3454 333.878 51.3236C333 51.3045 331.957 51.2177 330.749 51.0627L330.221 50.9922C330.025 50.9619 329.849 50.995 329.694 51.0916C329.538 51.1882 329.437 51.3279 329.391 51.5106C329.347 51.6843 329.37 51.8506 329.46 52.0097C329.551 52.1689 329.688 52.2865 329.873 52.3626L330.37 52.5525C331.506 52.9928 332.467 53.4129 333.253 53.8127C334.151 54.2697 334.859 54.7659 335.378 55.3015C335.897 55.8372 336.266 56.4659 336.485 57.188C336.705 57.9101 336.805 58.7844 336.787 59.811C336.774 60.5166 336.724 61.3256 336.636 62.2375L336.584 62.7452L336.525 63.2733C336.515 63.363 336.504 63.4536 336.493 63.5451C336.474 63.7348 336.51 63.9045 336.603 64.0547C336.696 64.2047 336.829 64.3017 337.003 64.3457C337.185 64.3921 337.353 64.3716 337.506 64.2841C337.659 64.1966 337.773 64.0651 337.847 63.8893C338.022 63.4626 338.193 63.0587 338.36 62.6774L338.558 62.2307C338.853 61.5772 339.134 60.9972 339.402 60.4908C339.878 59.5905 340.385 58.8776 340.921 58.3525C341.457 57.8275 342.08 57.4581 342.789 57.2443C343.499 57.0306 344.356 56.9324 345.361 56.9495C345.55 56.9528 345.746 56.9585 345.949 56.9672L346.366 56.988C346.437 56.9921 346.509 56.9963 346.582 57.0011L347.029 57.0326C347.105 57.0384 347.182 57.0445 347.26 57.051L347.737 57.0932C348.143 57.1313 348.569 57.1767 349.017 57.2298C349.215 57.2511 349.39 57.2128 349.541 57.1151C349.692 57.0173 349.79 56.8815 349.834 56.708C349.88 56.5253 349.86 56.3549 349.774 56.1969C349.688 56.0389 349.552 55.9262 349.365 55.8595L348.868 55.6693L348.392 55.4816C347.461 55.1084 346.66 54.7487 345.987 54.4024C345.09 53.941 344.379 53.4442 343.855 52.9118C343.33 52.3797 342.96 51.753 342.746 51.0321C342.531 50.3112 342.433 49.4351 342.453 48.4042C342.46 48.0175 342.478 47.6012 342.506 47.1547L342.537 46.6983L342.576 46.2222C342.582 46.1412 342.59 46.0593 342.597 45.9766L342.646 45.4706C342.654 45.3846 342.663 45.2979 342.673 45.2101L342.731 44.6741C342.753 44.4753 342.719 44.3036 342.629 44.1593C342.54 44.015 342.399 43.9184 342.208 43.8698L342.207 43.8687Z"
                  fill="#E9C15C"
                ></path>
                <path
                  d="M327.081 22.0306C326.908 21.9865 326.748 22.0066 326.6 22.0907C326.453 22.1747 326.336 22.3083 326.251 22.4908L326.15 22.7433L325.951 23.2327C325.521 24.2701 325.111 25.1603 324.721 25.9031C324.242 26.8171 323.733 27.539 323.196 28.0687C322.658 28.5985 322.034 28.9725 321.324 29.1907C320.613 29.4088 319.756 29.5073 318.752 29.4855C317.873 29.4664 316.83 29.3795 315.623 29.2246L315.095 29.1541C314.899 29.1238 314.723 29.1568 314.567 29.2535C314.412 29.3501 314.311 29.4897 314.264 29.6725C314.22 29.8462 314.244 30.0125 314.334 30.1716C314.425 30.3307 314.562 30.4484 314.746 30.5245L315.244 30.7144C316.38 31.1547 317.341 31.5747 318.127 31.9746C319.025 32.4316 319.733 32.9278 320.252 33.4634C320.771 33.999 321.14 34.6278 321.359 35.3499C321.579 36.0719 321.679 36.9463 321.661 37.9729C321.648 38.6785 321.598 39.4874 321.51 40.3994L321.458 40.9071L321.399 41.4352C321.389 41.5249 321.378 41.6155 321.366 41.7069C321.347 41.8967 321.384 42.0664 321.477 42.2165C321.57 42.3666 321.703 42.4636 321.876 42.5076C322.059 42.5539 322.226 42.5335 322.38 42.446C322.533 42.3584 322.647 42.2269 322.721 42.0512C322.896 41.6244 323.067 41.2206 323.234 40.8392L323.432 40.3925C323.727 39.7391 324.008 39.1591 324.276 38.6526C324.752 37.7524 325.259 37.0395 325.795 36.5144C326.331 35.9893 326.954 35.6199 327.663 35.4062C328.373 35.1924 329.23 35.0943 330.235 35.1114C330.423 35.1147 330.619 35.1204 330.823 35.1291L331.24 35.1499C331.311 35.1539 331.383 35.1582 331.456 35.1629L331.903 35.1944C331.979 35.2003 332.056 35.2064 332.134 35.2129L332.611 35.2551C333.016 35.2932 333.443 35.3386 333.891 35.3917C334.089 35.413 334.264 35.3747 334.415 35.2769C334.566 35.1792 334.664 35.0433 334.708 34.8699C334.754 34.6872 334.734 34.5168 334.648 34.3588C334.562 34.2007 334.426 34.0881 334.239 34.0213L333.741 33.8312L333.266 33.6435C332.335 33.2703 331.534 32.9106 330.861 32.5642C329.964 32.1028 329.253 31.606 328.728 31.0737C328.204 30.5415 327.834 29.9149 327.619 29.194C327.405 28.4731 327.307 27.597 327.327 26.5661C327.334 26.1794 327.352 25.763 327.38 25.3165L327.411 24.8602L327.449 24.3841C327.456 24.3031 327.464 24.2212 327.471 24.1385L327.519 23.6324C327.528 23.5465 327.537 23.4597 327.546 23.3719L327.605 22.836C327.626 22.6372 327.593 22.4655 327.503 22.3212C327.414 22.1769 327.273 22.0803 327.082 22.0316L327.081 22.0306Z"
                  fill="#E9C15C"
                ></path>
                <path
                  d="M250.293 69.5709C249.23 74.7976 254.206 77.5182 257.843 75.3725M261.821 78.0769C260.758 83.3036 265.734 86.0242 269.372 83.8786M242.643 75.3731C243.711 90.71 254.293 95.7506 267.094 90.5105"
                  stroke="#A87800"
                  stroke-width="2.408"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-[#2D2D2D] mb-2">
            Quick Results
          </h3>
          <p className="text-[#796866] text-[13px]">
            You won't have to wait for your likes, views, shares or follows.
            Famepeak begins work on your order immediately, and we promise
            delivery in 24 hours or less.
          </p>
        </div>

        {/* Satisfaction Guarantee Card */}
        <div className="bg-[#cdf9fe] rounded-3xl p-8 text-center relative overflow-hidden max-h-[352px]">
          <div className="relative h-20 md:h-32 mb-2 md:mb-6">
            <div className="absolute left-1/2 -translate-x-1/2 md:-top-[20px]">
              <svg
                className="md:w-[170px] md:h-[137px] w-[120px] h-[80px]"
                width="170"
                height="137"
                viewBox="0 0 170 137"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M69.4661 98.6883C62.3276 92.7385 58.219 91.2 58.2429 82.2535L58.3828 39.9721C58.4257 23.9022 71.6889 11.6787 88.0071 12.6701C104.325 13.6617 117.519 27.4927 117.476 43.5627L117.436 48.6785L117.831 101.35L94.6921 96.9056C85.8671 98.5166 76.6045 104.638 69.4661 98.6883Z"
                  fill="url(#paint0_linear_47_3472)"
                ></path>
                <path
                  d="M69.4661 98.6883C62.3276 92.7385 58.219 91.2 58.2429 82.2535L58.3828 39.9721C58.4257 23.9022 71.6889 11.6787 88.0071 12.6701C104.325 13.6617 117.519 27.4927 117.476 43.5627L117.436 48.6785L117.831 101.35L94.6921 96.9056C85.8671 98.5166 76.6045 104.638 69.4661 98.6883Z"
                  fill="#DFFCFF"
                ></path>
                <path
                  d="M56.7142 107.455C47.679 107.253 39.2406 102.973 33.8327 95.8495L6.54266 59.9028C-3.17114 47.1077 -0.501808 28.9887 12.5048 19.4328C25.5114 9.877 43.9299 12.5029 53.6437 25.298L58.4684 31.6531L95.0961 78.9125L80.109 96.8858C74.3772 103.76 65.7495 107.657 56.7142 107.455Z"
                  fill="url(#paint1_linear_47_3472)"
                ></path>
                <path
                  d="M56.7142 107.455C47.679 107.253 39.2406 102.973 33.8327 95.8495L6.54266 59.9028C-3.17114 47.1077 -0.501808 28.9887 12.5048 19.4328C25.5114 9.877 43.9299 12.5029 53.6437 25.298L58.4684 31.6531L95.0961 78.9125L80.109 96.8858C74.3772 103.76 65.7495 107.657 56.7142 107.455Z"
                  fill="#A0ECF4"
                ></path>
                <path
                  d="M115.429 106.394C124.231 106.194 132.452 101.956 137.72 94.9012L164.306 59.3028C173.769 46.6317 171.169 28.6883 158.498 19.225C145.827 9.76174 127.883 12.3622 118.42 25.0334L113.72 31.3269L78.0366 78.1283L92.6372 95.9275C98.2212 102.735 106.626 106.595 115.429 106.394Z"
                  fill="url(#paint2_linear_47_3472)"
                ></path>
                <path
                  d="M115.429 106.394C124.231 106.194 132.452 101.956 137.72 94.9012L164.306 59.3028C173.769 46.6317 171.169 28.6883 158.498 19.225C145.827 9.76174 127.883 12.3622 118.42 25.0334L113.72 31.3269L78.0366 78.1283L92.6372 95.9275C98.2212 102.735 106.626 106.595 115.429 106.394Z"
                  fill="#A0ECF4"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M92.3927 44.1111C89.0152 42.1179 84.8418 42.0342 81.3871 43.8904L49.909 60.804C44.4542 63.7349 42.4082 70.5329 45.3391 75.9877C48.27 81.4425 55.068 83.4885 60.5228 80.5576L76.5875 71.9258C76.0871 72.9615 75.8112 74.0955 75.8112 75.2843V127.258C75.8112 132.149 80.4817 136.114 86.2431 136.114C90.3777 136.114 93.9506 134.072 95.6385 131.111C97.0405 130.003 97.8763 128.608 97.8763 127.093V73.3858L109.655 80.3369C114.987 83.4841 121.862 81.7124 125.009 76.3795C128.157 71.0466 126.385 64.172 121.052 61.0247L92.3927 44.1111Z"
                  fill="url(#paint3_linear_47_3472)"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M92.3927 44.1111C89.0152 42.1179 84.8418 42.0342 81.3871 43.8904L49.909 60.804C44.4542 63.7349 42.4082 70.5329 45.3391 75.9877C48.27 81.4425 55.068 83.4885 60.5228 80.5576L76.5875 71.9258C76.0871 72.9615 75.8112 74.0955 75.8112 75.2843V127.258C75.8112 132.149 80.4817 136.114 86.2431 136.114C90.3777 136.114 93.9506 134.072 95.6385 131.111C97.0405 130.003 97.8763 128.608 97.8763 127.093V73.3858L109.655 80.3369C114.987 83.4841 121.862 81.7124 125.009 76.3795C128.157 71.0466 126.385 64.172 121.052 61.0247L92.3927 44.1111Z"
                  fill="white"
                ></path>
                <path
                  d="M80.1275 23.3689C81.405 26.4194 84.9052 26.0796 86.0222 23.7112M89.0046 23.7112C90.2821 26.7617 93.7822 26.4219 94.8992 24.0535M74.2329 25.7269C80.1275 33.2191 96.3729 33.2571 101.11 26.1072"
                  stroke="#57D3E0"
                  stroke-width="1.82465"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M16.8098 36.4289C20.3659 38.5889 23.6769 35.6546 23.0623 32.4181M26.0976 30.2125C29.6538 32.3725 32.9648 29.4382 32.3501 26.2017M15.071 42.661C26.611 45.9271 39.0811 38.101 38.6145 27.3212"
                  stroke="#3EB2BE"
                  stroke-width="1.82465"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M142.643 26.2908C141.814 30.3681 145.696 32.4905 148.533 30.8167M151.636 32.9264C150.807 37.0037 154.689 39.1261 157.527 37.4522M136.676 30.8171C137.509 42.7814 145.764 46.7136 155.75 42.6258"
                  stroke="#3EB2BE"
                  stroke-width="1.82465"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_47_3472"
                    x1="87.8533"
                    y1="9.80589"
                    x2="81.9462"
                    y2="103.459"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FFA3A3"></stop>
                    <stop offset="1" stop-color="#FDDC5D"></stop>
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_47_3472"
                    x1="10.8128"
                    y1="17.5846"
                    x2="72.5859"
                    y2="96.1918"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FFA3A3"></stop>
                    <stop offset="1" stop-color="#FDDC5D"></stop>
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_47_3472"
                    x1="160.146"
                    y1="17.3946"
                    x2="98.7418"
                    y2="94.262"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FFA3A3"></stop>
                    <stop offset="1" stop-color="#FDDC5D"></stop>
                  </linearGradient>
                  <linearGradient
                    id="paint3_linear_47_3472"
                    x1="118.932"
                    y1="157.527"
                    x2="40.8339"
                    y2="98.8856"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white"></stop>
                    <stop offset="1" stop-color="#FFE8F6"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-[#2D2D2D] mb-2">
            Satisfaction Guarantee
          </h3>
          <p className="text-[#4b868c] text-[13px]">
            Famepeak wants you to feel comfortable and confident through the
            entire process. We offer a complete refund on any order that didn't
            complete correctly.
          </p>
        </div>

        {/* Support Staff Card */}
        <div className="col-span-2 md:col-span-1">
          <div className="bg-[#b083eb] rounded-3xl p-3 md:p-8 text-center relative overflow-hidden max-h-[352px]">
            <div className="relative h-32 md:mb-6 mb-1">
              <div className="absolute left-1/2 -translate-x-1/2 md:-top-[20px] top-0">
                <svg
                  width="196"
                  height="106"
                  viewBox="0 0 196 106"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="45.1055"
                    cy="61.2417"
                    rx="45"
                    ry="44.5"
                    fill="#9F61F0"
                  ></ellipse>
                  <mask
                    id="mask0_364_3780"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="16"
                    width="90"
                    height="90"
                  >
                    <circle
                      cx="44.8964"
                      cy="61.0522"
                      r="44.787"
                      fill="#B083EB"
                    ></circle>
                  </mask>
                  <g mask="url(#mask0_364_3780)">
                    <path
                      d="M55.4736 123.772C61.8682 119.011 65.717 111.573 65.9101 103.603L66.8846 63.3833C67.2315 49.0672 55.9072 37.1806 41.5911 36.8337C27.2751 36.4869 15.3884 47.8111 15.0416 62.1272L14.8693 69.2377L13.0491 122.497L33.1587 127.988C40.8496 130.088 49.079 128.534 55.4736 123.772Z"
                      fill="url(#paint0_linear_364_3780)"
                    ></path>
                    <path
                      d="M55.4736 123.772C61.8682 119.011 65.717 111.573 65.9101 103.603L66.8846 63.3833C67.2315 49.0672 55.9072 37.1806 41.5911 36.8337C27.2751 36.4869 15.3884 47.8111 15.0416 62.1272L14.8693 69.2377L13.0491 122.497L33.1587 127.988C40.8496 130.088 49.079 128.534 55.4736 123.772Z"
                      fill="#D5B5FF"
                    ></path>
                    <path
                      d="M33.589 50.3622C35.1139 53.8073 39.0926 53.3401 40.3105 50.617M43.7073 50.5487C45.2321 53.9938 49.2108 53.5266 50.4287 50.8035M31.555 56.8318C38.4403 65.2299 46.5971 63.8068 51.8281 55.555"
                      stroke="#6635A6"
                      stroke-width="1.41021"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                  <ellipse
                    cx="150.105"
                    cy="61.2417"
                    rx="45"
                    ry="44.5"
                    fill="#9F61F0"
                  ></ellipse>
                  <mask
                    id="mask1_364_3780"
                    maskUnits="userSpaceOnUse"
                    x="105"
                    y="16"
                    width="91"
                    height="90"
                  >
                    <circle
                      cx="150.318"
                      cy="61.0483"
                      r="44.787"
                      fill="#B083EB"
                    ></circle>
                  </mask>
                  <g mask="url(#mask1_364_3780)">
                    <path
                      d="M168.362 117.149C174.817 111.908 178.502 103.989 178.354 95.6752L177.609 53.7226C177.344 38.7897 165.023 26.8993 150.09 27.1646C135.157 27.43 123.267 39.7507 123.532 54.6836L123.664 62.1005L124.099 117.678L145.294 122.519C153.4 124.371 161.907 122.391 168.362 117.149Z"
                      fill="url(#paint1_linear_364_3780)"
                    ></path>
                    <path
                      d="M168.362 117.149C174.817 111.908 178.502 103.989 178.354 95.6752L177.609 53.7226C177.344 38.7897 165.023 26.8993 150.09 27.1646C135.157 27.43 123.267 39.7507 123.532 54.6836L123.664 62.1005L124.099 117.678L145.294 122.519C153.4 124.371 161.907 122.391 168.362 117.149Z"
                      fill="#D5B5FF"
                    ></path>
                    <path
                      d="M142.338 41.6055C144.078 45.1287 148.203 44.4676 149.353 41.5768M152.89 41.3568C154.63 44.88 158.755 44.2189 159.905 41.328M140.502 48.4361C148.044 56.8857 156.482 55.0456 161.571 46.2179"
                      stroke="#6635A6"
                      stroke-width="1.47078"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <rect
                      x="167.453"
                      y="41.062"
                      width="15.1587"
                      height="26.8722"
                      rx="4.51906"
                      transform="rotate(16.165 167.453 41.062)"
                      fill="#612AA9"
                    ></rect>
                    <rect
                      opacity="0.2"
                      x="162.828"
                      y="76.0928"
                      width="15.8477"
                      height="38.3163"
                      rx="7.92386"
                      transform="rotate(-8.3767 162.828 76.0928)"
                      fill="#8480DB"
                    ></rect>
                    <rect
                      x="165.582"
                      y="66.4409"
                      width="15.8477"
                      height="38.3163"
                      rx="7.92386"
                      transform="rotate(-8.3767 165.582 66.4409)"
                      fill="#D5B5FF"
                    ></rect>
                  </g>
                  <g filter="url(#filter0_d_364_3780)">
                    <path
                      d="M96.1055 20.7416C96.1055 31.7943 104.958 40.7417 115.893 40.7417L138.379 40.7417C140.651 40.7417 141.929 38.0623 140.509 36.2921L135.634 30.2634L135.634 20.7418C135.634 9.68913 126.781 0.741702 115.846 0.741702C104.958 0.741703 96.1057 9.68913 96.1057 20.7418L96.1055 20.7416Z"
                      fill="#EADAFF"
                    ></path>
                  </g>
                  <rect
                    x="6.10547"
                    y="53.7417"
                    width="11"
                    height="21"
                    rx="5.5"
                    fill="#612AA9"
                  ></rect>
                  <rect
                    x="66.1055"
                    y="53.7417"
                    width="10"
                    height="21"
                    rx="5"
                    fill="#612AA9"
                  ></rect>
                  <path
                    d="M12.1055 56.7417C12.1055 46.2483 20.5966 37.7417 31.071 37.7417H53.14C63.6143 37.7417 72.1055 46.2483 72.1055 56.7417"
                    stroke="#612AA9"
                    stroke-width="1.29116"
                  ></path>
                  <g filter="url(#filter1_d_364_3780)">
                    <path
                      d="M90.1055 40.2416C90.1055 47.7022 84.0072 53.7417 76.474 53.7417L60.9837 53.7417C59.4185 53.7417 58.5379 51.9331 59.5163 50.7382L62.875 46.6689L62.875 40.2418C62.875 32.7812 68.9733 26.7417 76.5065 26.7417C84.007 26.7417 90.1053 32.7812 90.1053 40.2418L90.1055 40.2416Z"
                      fill="#EADAFF"
                    ></path>
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_364_3780"
                      x="92.1055"
                      y="0.741699"
                      width="53"
                      height="48"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                      ></feFlood>
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      ></feColorMatrix>
                      <feOffset dy="4"></feOffset>
                      <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                      <feComposite in2="hardAlpha" operator="out"></feComposite>
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                      ></feColorMatrix>
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_364_3780"
                      ></feBlend>
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_364_3780"
                        result="shape"
                      ></feBlend>
                    </filter>
                    <filter
                      id="filter1_d_364_3780"
                      x="55.1055"
                      y="26.7417"
                      width="39"
                      height="35"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                      ></feFlood>
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      ></feColorMatrix>
                      <feOffset dy="4"></feOffset>
                      <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                      <feComposite in2="hardAlpha" operator="out"></feComposite>
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                      ></feColorMatrix>
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_364_3780"
                      ></feBlend>
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_364_3780"
                        result="shape"
                      ></feBlend>
                    </filter>
                    <linearGradient
                      id="paint0_linear_364_3780"
                      x1="41.849"
                      y1="34.6183"
                      x2="36.7934"
                      y2="123.559"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFA3A3"></stop>
                      <stop offset="1" stop-color="#FDDC5D"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_364_3780"
                      x1="150.262"
                      y1="24.8448"
                      x2="148.888"
                      y2="117.745"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFA3A3"></stop>
                      <stop offset="1" stop-color="#FDDC5D"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">
              Experienced Support Staff
            </h3>
            <p className="text-white text-[13px]">
              We have a trained, friendly customer support staff available 24/7
              to answer all your questions and ensure your experience is as easy
              and effective as possible.
            </p>
          </div>
        </div>
      </div>

      <p className="text-center text-[14px] text-[#626366] mt-8">
        Still not sure? Check our{" "}
        <a href="#client-stories" style={{ color: mainColor }}>
          customer reviews
        </a>{" "}
        – and then click{" "}
        <a href="/order" style={{ color: mainColor }}>
          {" "}
          here{" "}
        </a>
        to get started <br className="hidden md:block" /> with the best provider
        of TikTok social media services: Famepeak!
      </p>
    </div>
  );
}
